/**
 * 直播銷售管道
 * FB_PAGE：粉絲專頁
 * HANDSUP：liveweb
 */
export const FB_PAGE = 'fb_page'
export const HANDSUP = 'handsup'
export const M17_LIVE = '17live'
export const M17_LIVE_V_2 = '17live_v2'
